/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2020 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
import { Preview } from "components/preview/Preview";
import { inject } from "mobx-react";
import { envUtil } from "dc-core";
import { getPreviewWidth } from "selectors/previewSelectors";
import { shouldShowScrubber } from "selectors/pagedViewState";
import { getShouldUseModernViewer } from "selectors/appSelectors";
import { getFileExtension, getFileName, getTitle, getFileMetaData, getAssetURI } from "selectors/documentSelectors";
import { getLHPVisibility } from "selectors/lhpSelectors";
import { getNamePartsFromFullName } from "dc-preview-utils/src/Utils/UrlUtils";
import { supportedFileExtensions } from "../../constants/enums";
import { getLastPartFromPath } from "../../utils/UrlUtils";

const mapStoreToProps = (stores, ownProps) => {
  const fileExtensions = [];
  fileExtensions.push(getFileExtension(stores));
  fileExtensions.push(getNamePartsFromFullName(getFileName(stores)).fileExtension);
  fileExtensions.push(getNamePartsFromFullName(getTitle(stores)).fileExtension);
  fileExtensions.push(getNamePartsFromFullName(getFileMetaData(stores).fileName).fileExtension);
  if (envUtil.getEnvVar("app_identifier") !== "dc-web-app" && envUtil.getEnvVar("app_identifier") !== "dc-web-pwa")
    fileExtensions.push(getNamePartsFromFullName(getLastPartFromPath(getAssetURI(stores))).fileExtension);

  let isPreviewable = false;
  for (let i = 0; i < fileExtensions.length; i++) {
    if (Object.values(supportedFileExtensions).includes(fileExtensions[i].toLowerCase())) {
      isPreviewable = true;
      break;
    }
  }

  return {
    ...ownProps,
    setDimensions: dimensions => {
      stores.previewStore.setDimensions(dimensions);
    },
    showLHP: getLHPVisibility(stores),
    width: getPreviewWidth(stores),
    showScrubber: shouldShowScrubber(stores),
    shouldUseModernViewer: getShouldUseModernViewer(stores),
    isPreviewable
  };
};
const PreviewContainer = inject(mapStoreToProps)(Preview);

export { PreviewContainer };
